import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-component-loader',
	templateUrl: './component-loader.component.html',
	styleUrls: ['./component-loader.component.css'],
})
export class ComponentLoaderComponent implements OnInit {
	@Input() loading: boolean = true;
	@Input() w: number = 60;
	@Input() h: number = 60;
	@Input() f: number = 6;
	@Input() text: string = '';
	@Input() style: string = '';
	@Input() spinStyle: string = '';
	constructor() {}

	ngOnInit(): void {}
}
